import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import {
  Campaign as ApiCampaign,
  CampaignScore as ApiCampaignScore,
  CampaignFieldingStat as ApiCampaignFieldingStat,
  CampaignHealthStatus as ApiCampaignHealthStatus,
  Tapi,
} from '../api/tapiTypes';
import { campaignAlertsSlice } from '../campaignAlerts';

type ApiCampaignAttributes = ApiCampaign['attributes'];
export interface Campaign extends ApiCampaignAttributes {
  alertIds?: string[];
  campaignScore?: ApiCampaignScore['attributes'];
  fieldingStats?: ApiCampaignFieldingStat['attributes'];
  healthStatus?: 'Pass' | 'Serious' | 'Critical' | 'Minor';
}

export const campaignsAdapter = createEntityAdapter<Campaign>({});

export const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState: campaignsAdapter.getInitialState(),
  reducers: {
    campaignsFetched: campaignsAdapter.upsertMany,
    campaignFetched: (
      state,
      action: PayloadAction<Tapi['V1CampaignsDetail']['ResponseBody']>
    ) => {
      const { payload: rawCampaign } = action;
      const campaign: Campaign = { ...rawCampaign.data.attributes };
      rawCampaign.included?.forEach((included) => {
        if (included) {
          // TODO: we can improve the inference of these types
          switch (included.type) {
            case 'campaign_score':
              campaign.campaignScore = (
                included as ApiCampaignScore
              ).attributes;
              break;
            case 'campaign_fielding_stat':
              campaign.fieldingStats = (
                included as ApiCampaignFieldingStat
              ).attributes;
              break;
            default:
              break;
          }
        }
      });

      return campaignsAdapter.upsertOne(state, campaign);
    },
    campaignHealthStatusFetched: (
      state,
      action: PayloadAction<ApiCampaignHealthStatus['data']['attributes']>
    ) => {
      const {
        payload: { status, campaign_id },
      } = action;

      const campaign = { id: campaign_id, healthStatus: status } as Campaign;
      return campaignsAdapter.upsertOne(state, campaign);
    },
    campaignUpdated: campaignsAdapter.updateOne,
  },
  extraReducers: (builder) => {
    builder.addCase(
      campaignAlertsSlice.actions.campaignAlertsFetched,
      (state, { payload: { campaignId, alerts } }) => {
        const alertIds = alerts.map((alert) => alert.id);

        campaignsAdapter.updateOne(state, {
          id: campaignId,
          changes: {
            alertIds,
          },
        });
      }
    );
  },
});
